import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Lock, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';

// MediaKshetra Brand Colors - Enterprise Dark Theme
const GOLD = '#D4A84B';
const GOLD_MUTED = '#B8975F';
const DARK_BG = '#0E0E0E';
const CARD_BG = '#141414';
const MUTED = '#9CA3AF';

export const LoginPage = () => {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: DARK_BG }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-8">
            <div className="w-10 h-10 rounded flex items-center justify-center" style={{ backgroundColor: GOLD }}>
              <BarChart3 className="w-6 h-6 text-black" />
            </div>
            <span className="text-xl font-semibold tracking-tight text-white">MediaKshetra</span>
            <span className="text-xs tracking-widest uppercase" style={{ color: GOLD_MUTED }}>GIOS</span>
          </div>
          
          <h1 className="text-2xl sm:text-3xl font-light text-white mb-3 tracking-tight">
            Access Your Growth Infrastructure
          </h1>
          <p className="text-sm" style={{ color: MUTED }}>
            Secure institutional access to your performance environment.
          </p>
        </div>

        {/* Login Card */}
        <div className="rounded-lg p-8" style={{ backgroundColor: CARD_BG, border: `1px solid ${GOLD}1A` }}>
          {/* Private Beta Badge */}
          <div className="flex justify-center mb-6">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 text-[10px] tracking-wider uppercase rounded"
                  style={{ backgroundColor: `${GOLD}0D`, color: GOLD_MUTED, border: `1px solid ${GOLD}1A` }}>
              <Lock className="w-3 h-3" />
              Private Beta Access
            </span>
          </div>
          
          <Button
            onClick={handleLogin}
            data-testid="google-login-button"
            className="w-full h-12 flex items-center justify-center space-x-3 font-medium tracking-wide transition-all duration-300"
            style={{ backgroundColor: GOLD, color: '#000' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            <span>Enter GIOS</span>
          </Button>
          
          {/* Security Note */}
          <div className="flex items-center justify-center gap-2 mt-6 pt-6" style={{ borderTop: `1px solid ${GOLD}0D` }}>
            <Shield className="w-3 h-3" style={{ color: GOLD_MUTED }} />
            <p className="text-[10px] tracking-wide" style={{ color: MUTED }}>
              Enterprise-grade authentication & session security
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-[10px] tracking-wider uppercase" style={{ color: `${MUTED}60` }}>
            MediaKshetra Confidential Environment
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
